<template>
  <div>
    <header class="uk-margin-medium-bottom">
      <div
          class="uk-navbar-container tm-navbar-container"
          uk-sticky="cls-active: tm-navbar-container-fixed">
        <div class="uk-container" uk-navbar>
          <div class="uk-navbar-left" v-if="currentUser.authorities[0].authority != 'ROLE_PROCTOR'">
            <button
                class="uk-navbar-toggle uk-hidden@m"
                uk-toggle="target: #nav-offcanvas"
                uk-navbar-toggle-icon
            ></button>
            <router-link
                class="uk-navbar-item uk-logo"
                tag="a" :to="{name: 'organization'}"
                v-if="$store.getters.currentUser.organizs.length > 0">
              <img style="max-width: 120px; max-height: 58px;"
                   v-if="$store.getters.currentUser.organizs[0].organizImg.includes('http')"
                   :src="$store.getters.currentUser.organizs[0].organizImg" alt="Logo organization">
              <img style="max-width: 120px; max-height: 58px;"
                   v-else-if="$store.getters.currentUser.organizs[0].organizImg.includes('https')"
                   :src="$store.getters.currentUser.organizs[0].organizImg" alt="Logo organization">
              <img src="../../assets/septentrions.png" width="90" v-else>
            </router-link>
            <nav class="uk-visible@m">
              <ul class="uk-navbar-nav">
                <li v-if="$store.getters.isLoggedIn" v-show="currentUser.authorities[0].authority === 'ROLE_ADMIN'">
                  <a href="#">{{ $t("organization.orgaNav.reg") }}
                    <span class="uk-margin-xsmall-left" uk-icon="icon: chevron-down; ratio: .75;"></span>
                  </a>
                  <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                      <li>
                        <router-link tag="a" :to="{name: 'professorlist', params: {type: 0}}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.regProf") }}</span>
                        </router-link>
                      </li>
<!--                      <li>-->
<!--                        <router-link tag="a" :to="{name: 'proctorlist', params: {type: 0}}">-->
<!--                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>-->
<!--                          <span class="uk-icon">Proctor</span>-->
<!--                        </router-link>-->
<!--                      </li>-->
                      <li>
                        <router-link tag="a" :to="{name: 'studentlist', params: {id:0}}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.regStu") }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link tag="a" :to="{name: 'excelupload'}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("additional.excelupload") }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <router-link tag="a" :to="{ name: 'organizcategory', params: { pagetype: 'main' }}">
                    {{ $t("organization.orgaNav.cat") }}
                  </router-link>
                </li>
                <li>
                  <a href="#">
                    {{ $t("organization.orgaNav.ques") }}
                    <span class="uk-margin-xsmall-left"
                          uk-icon="icon: chevron-down; ratio: .75;">
                    </span>
                  </a>
                  <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                      <li  style="margin-top: 10px;">
                        <router-link tag="a" :to="{name: 'OrganizationQuestionList'}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.quesList") }}</span>
                        </router-link>
                      </li>
                      <li  style="margin-top: 10px;">
                        <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                        <span class="uk-icon" @click="createQuestion('normal')" style="cursor: pointer">
                          {{ $t("organization.orgaNav.quesRegTest") }}</span>
                      </li>
                      <li style="margin-top: 13px;">
                        <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                        <span class="uk-icon" @click="createQuestion('passage')" style="cursor: pointer">
                          {{ $t("pQuesReg") }}
                        </span>
                      </li>
                      <li  style="margin-top: 10px;">
                        <router-link tag="a"
                             :to="{name: 'OrganizationQuestion',params: {questionId: 0}}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("additional.excelupload") }}</span>
                        </router-link>
                      </li>
<!--                      <li>-->
<!--                        <router-link tag="a" :to="{name: 'OrganizationQuestionPurchased'}">-->
<!--                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>-->
<!--                          <span class="uk-icon">{{ $t("organization.orgaNav.quesPurch") }}</span>-->
<!--                        </router-link>-->
<!--                      </li>-->
                    </ul>
                  </div>
                </li>
                <li>
                  <a href="#">
                    {{ $t("organization.orgaNav.exam") }}
                    <span class="uk-margin-xsmall-left"
                                                               uk-icon="icon: chevron-down; ratio: .75;"></span>
                  </a>
                  <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                      <li>
                        <router-link tag="a" :to="{name: 'OrganizationExamRegister',params: { examId: 0}}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.eReg") }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link tag="a" :to="{name: 'OrganizationExamList'}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.eList") }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link tag="a" :to="{name: 'OrganizationSurveyAdd'}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("organization.orgaNav.sList") }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link tag="a" :to="{name: 'SurveyResultList'}">
                          <span class="uk-icon" uk-icon="icon: chevron-right; ratio: .75;"></span>
                          <span class="uk-icon">{{ $t("additional.surveyResult") }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'OrganizationExamResultView'}">
                    {{ $t("organization.orgaNav.examAnaliz") }}
                  </router-link>
                </li>
<!--                <li v-show="currentUser.authorities[0].authority === 'ROLE_ADMIN'">-->
<!--                  <router-link tag="a" :to="{ name: 'zipupload'}">-->
<!--                    {{ $t('tmsupload') }}-->
<!--                  </router-link>-->
<!--                </li>-->
              </ul>
            </nav>
          </div>
          <div class="uk-navbar-left" v-else>
            <button
                class="uk-navbar-toggle uk-hidden@m"
                uk-toggle="target: #nav-offcanvas"
                uk-navbar-toggle-icon
            ></button>
            <router-link
                class="uk-navbar-item uk-logo"
                tag="a" :to="{name: 'OrganizationProcExamList'}"
                v-if="$store.getters.currentUser.organizs.length > 0">
              <div class="uk-navbar-item uk-logo"
                  v-if="$store.getters.currentUser.organizs.length > 0">
                <img style="max-width: 120px; max-height: 58px;"
                     v-if="$store.getters.currentUser.organizs[0].organizImg.includes('http')"
                     :src="$store.getters.currentUser.organizs[0].organizImg" alt="Logo organization">
                <img style="max-width: 120px; max-height: 58px;"
                     v-else-if="$store.getters.currentUser.organizs[0].organizImg.includes('https')"
                     :src="$store.getters.currentUser.organizs[0].organizImg" alt="Logo organization">
                <img src="../../assets/septentrions.png" width="90" v-else>
              </div>
            </router-link>
            <nav class="uk-visible@m">
              <ul class="uk-navbar-nav">
                <li>
                  <router-link tag="a" :to="{ name: 'OrganizationProcExamList'}">
                    {{ $t("organization.orgaNav.exam") }}
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
          <span class="uk-hidden">{{ isIdle }}</span>
          <div class="uk-navbar-right">
            <router-link
                tag="a"
                :to="{name: 'myhistory'}"
                class="uk-navbar-item uk-link-muted tm-navbar-button">
              <span class="uk-icon" uk-icon="user"></span>
              {{ $store.getters.currentUser.firstName }}
              <i class="uk-icon"
                 uk-icon="icon: chevron-down; ratio: .75;"
              ></i>
            </router-link>
            <div class="uk-padding-small uk-margin-remove"
                 uk-dropdown="pos: bottom-right; offset: -10; delay-hide: 200;"
                 style="min-width: 150px;">
              <ul class="uk-nav uk-dropdown-nav">
                <li>
                  <router-link tag="a" :to="{name: 'mysettings'}">
                    {{ $t("navMenu.set") }}
                  </router-link>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'myinfo'}">
                    {{ $t("organization.orgaNav.pInfo") }}
                  </router-link>
                </li>
                <li v-if="$store.getters.isLoggedIn" class="uk-nav-divider"></li>
                <li v-if="$store.getters.isLoggedIn">
                  <a href="#" @click.prevent="logout">
                    <span data-uk-icon="icon: sign-out"></span>
                    {{ $t("organization.orgaNav.logout") }}
                  </a>
                </li>
              </ul>
            </div>
            <nav class="uk-visible@l">
              <ul class="uk-navbar-nav">
                <li>
                  <img src="../../assets/minimize/lang.png" style="width:30px;" v-if="selectedFlag == ''">
                  <img :src="selectedFlag" style="width:40px; border: 1px solid #d0d0d0" v-else>
                  <div class="uk-navbar-dropdown  uk-padding-small" style="width:180px"
                       uk-dropdown="pos: bottom-justify">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                      <li :key="index" @click.prevent="selected(flag)"
                          class="countryFlag uk-margin-small-bottom"
                          v-for="(flag,index) in country" style="cursor: pointer">
                        <img alt="" :src="flag.url" class="flagshere">
                        <span class="uk-margin-small-left uk-text-capitalize">{{ flag.name }}</span>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import store from '@/store/store'

export default {
  computed: {
    ...mapGetters(['isLoggedIn', 'cartValue', 'currentUser', 'cartItemList']),
    numItems() {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity;
        return total
      }, 0)
    },
    isIdle() {
      if (this.$store.state.idleVue.isIdle == true) {
        this.$store.dispatch('setToken', null);
        this.$store.dispatch('setUser', null);
        window.location.href = "/login"
      }
      return this.$store.state.idleVue.isIdle;
    },
    userEmail() {
      return this.isLoggedIn ? this.currentUser.email : ''
    }
  },
  data() {
    return {
      searchval: '',
      logoutdate: 'date: 2019-03-12T05:25:26+00:00',
      isAdmin: false,
      localPath: '/ubtexam/teacher/qbank',
      // localPath: 'http://localhost:8084/ubtexam/teacher/qbank',
      localPath2: '/ubtexam/teacher/passageqbank',
      // localPath2: 'http://localhost:8084/ubtexam/teacher/passageqbank',
      country: [
        {
          cName: 'kr',
          name: 'South Korea',
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAAF4UlEQVRoQ+1ZbUyTVxR+2kL5lLFWhgwmwiSLDsjMljGdmmmEjG+QhY0PRaYJy5ZJTITglDiHGAQzFpMlssiQ7zmCUj4bWNSok7ksxIAalrgxI0KqAs6BUKDtcu5Sg1D63rdFNMObNP3xnnvPee557nnPfV6JwWAwYAENyXPA//NsW5zhhw8fwtHR8alsjzW+LQJMxz4iIgIODg6orq6Gra3tvACfmJhAQkICRkdH0djYCIlEItqvRYBPnDiB1NRUpKSkIDw8HJOTkyyQJzloY21sbNDU1ITS0lKUlJRg27Ztol2KBtzb24uAgAA4OTmhtbUV69atg729Pc6fPw9nZ2e4u7uLDsLcBI1Gg+HhYaxfvx5jY2O4cOECQkJCMDIygq6uLnh5eYnyJwqwkcotLS1oaGhAUVERo5ZKpcLx48dx6dIldHZ2wsPDQ1QQsxn39/cjMDAQa9aswY4dOxAdHc2OUlpaGiIjI5Geno7CwkJRvkQBNlKZqLRx40Zs3bqV/YKDg7FlyxYkJSWhoqJCVABCxsnJyaisrER5eTna2tpQVlbGKO3i4sKyS5tC4HkHN+DZqExBEK3t7OwYxZRKpaBvg07PbCQyqaDtwMAAO0JarZbRmTaXilZHRwfb9KGhIVy9ehWenp6CazGfPI2HkcrNzc2MwkRlonR9fT2Ki4sZpevq6hjlTA39mBYDp1ox2HgWwx3XMXFngJnZvqSE86qVUERugHJzCKT2dibn0/rx8fGMPbSx5IeyStQmilPhpHh4qjYXYGuofO/HZtzc9w3G+++azYDcww3eB3dhcXyoSbsbN26gqqoKfn5+UKvVjNr0O3PmDCg+3qrNBbi2thY5OTnM4dq1a9n7V4jKBp0OPbsOQVNyiotqRiP31Dj4FO6BRCZ7bN7g4CD8/f1nUPvixYtITExEdnY24uLiBH1xAaZV9Ho9jhw5gqysLEZhISr/ufMgNCW1ggGYMiDQvkf3zXhEfmNiYhilt2/fzv7z8vKwe/duSKXC9YD7DE/13N7ejp6eHlaRZ6vKd2rU+OPjPRaBNU7yK87F4viwGWsYqzZVbh8fH6xevVqUH+4MT12VmoG9e/ciPz8fCoXiMYdj2klcDoyCvK9fVCDTjeVL3LCqq2FGISNqZ2ZmIjc316ImxyLA5pA0q9rxYvKnVoE1Tl5e9BXcEvnfsTxO5xzwzvQiJHx/jMc3s9FJJPhL7oxxiRRLx0fgpJ98NJdeV69Vfc29Fo/hnAP2DTuE4p9PwV6vM+vfAAl+UCxDudIH92VyZmtjMCD4QT8+v9MNV9045J7ueLNbzYOD22ZOAev0Bji+m41dvZ2Ivn/LbBCHl/hD5Wq68adMf3fzF7wgNSDo7mWujowX8RMBbK8dYwFT4KaGyvUVHF7yutkYo+/3Imug+9kGTAiWRuThluZvuOomGDWJojaG/3rnIZkc5UpfnFQsg5BySEfi7EgX3ulu4U0el92cZpg8bs6owOlz1x45pyJEmdZKZLgpd2JFine0rZRhU+lBXnMuuzkHXNbUgZQva7icCxldz9iAFfEhQmainlsEWKjxeDUmH333/hEVyHTj5QpH/K7KfPqNB09rWaW+gqTsk1YBrs75EB+9/8aMNeattRR7efjk0GkUnf7VItBpsW/j2BexM+bO2+XBkuuhTq/HZ3kq0aAJ7LdZ0ZBNu/3M6/XQGgGgWn0FGUdbcPvuA7PZftnNBQU7Q5FogsY0cV4FAFMSD2lcJM3SmRKSeEa1E6j5qQt1567ht+u3oRkcZuDdlc54a4UXYt9biQ82BcDBzrSgP1XiCQ0NZZItCXhGiScsLIxbmOeu0lNFPBLTSFzbv38/CgoKRIt41ILSkEmF38nTRbyMjAwcOHAA3t7eCAoKYiKeGH2aGzAFaA21LapeAGPQdJmWtKxFixaxLPf19SEqKop7eVGAF5wQT9u4oD61GHmzoD6mEegF97mUQFvzUZq7wsxiaI1vUUXL2kCfhfnPAT8LWXiSMfwL3anettfuonIAAAAASUVORK5CYII=',
          select: false
        },
        {
          cName: 'mn',
          name: 'Mongolia',
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAAC1klEQVRoQ+2aMUxTURSGv9M+WtoKpWChRB0gJhoSXUAXTFxMjKOJkxIHg0YTRCUhMbqYSIwaNSIxDA5MMjDrKjG6OajBRY2MBmhSSmkLFN475rVFjaFgUpZeeqf2tve+/Of///POue+JnmhVtmmkghEu9L/dpt3Av7rMy8dHt20/dyOpAi4jnlWGywieu7Qq6TID+N8e1lYHbJA5z6aXNEbSzn4H6VxCJkKwSU43A7CA3ZfBU5+DkQiSKk2yEYA15sDFhQKzr0PIR19JxEYAxgf6JI4EHPRWFJkt7WMzAAMaUzSoeKZ3QNLSdhtuJBC/g76IIB8Ml7TenEc6lvO+1XkLuR4tmamNkLSOxJHw2u9EpVdakczGeaviAWsIGEwg7SsFhFkvOtiMLJoKuDsHWZD+BHgVHW+AtBd5v7GPK5/hzhwcWkHfhcADcnAl7195FdiQ4ooHjID2LiLdBdPqNz/yKAI5kyQdcqC2WDCnPVDnoG02+BT5boE7V+vgBoMVKXwvjspk+FwKTmYgJ2hfDC4tIF3ZAsPTfhiOIENz+UAwGYSxsDmA6Y3lmdTTWdhtI2N1sAo8nzUU8P1G2PfnHpyn8qcF/fOGAnYl68r77+HOdS0bCvhyC1igh1dhTZCvFrg1yLDBHtbeFNK1hGa8OJ9CeMcD8MxQD+u9KHJnDv0cgBkLbVtDJgPI2aSZktaJMNKThCUPzo8A0pKDKT9yJGsq4Ho4s4hOBZGOJSRko292GQx4KIr2pJE1hbgXOZ5GRxsLrJtaeNincniOpcFSSHqRhw3mJi2uNUNQ0b02NNnwxYekBR7EDWV4xxUed5tgzz+l5awFAwkzGdaBFriaRA4UD/FmauBpI3LbVEm73VIN6PlFaLRhNFzwsFHdkpuN13v6nNvlu+8JFLuH9QdpvuIHh3yNXdkHAKWflW35S2WeeGwJq/QfqoDLCJ67tPrKQ5kBdJf/AqoIiX9cXkKtAAAAAElFTkSuQmCC',
          select: false
        },
        {
          cName: 'in',
          name: 'Indonesia',
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAAAeUlEQVRoQ+3YWxWAMBAD0awj/JuopPDNQ8Hs4CC5gR46TZpFzxgYrq0wHDgKKwxrwEnDQD9xFFYY1oCThoH60XLSThrWwPS6ll3xnLMscGtg2Gv7iDNVmOybKMz2VZjuq7DCuAY8lnCkr0AKKwxrwEnDQH/upZf9D9+DLnexxOfG0gAAAABJRU5ErkJggg==',
          select: false
        },
        {
          cName: 'en',
          name: 'English',
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAACdUlEQVRoQ+1YQWgTQRSdaTWpWC22IA0YLF4SVigoVNvTlkIuSgQP5lihUL2JXr158V7aixUP7Ul7kob2kkNbBKutiAiG5Kau0CB0Q2tFEqUr/yUrWmjikBn4MJnLz8v8/7Nv/5u3SeTI8J1AGFz3v7ww2F29tSTCly4nUbnxuoCoE7MknE4Pg2g2+wpRJ2ZJuKNDgmg8fhrR875qwfv7gVhdfqCuO4MVkHTYf/xmCi/n53KIhOlWzDXAjfJp7+X6lMHLV28Nwj09x1FZqfxEjEaPasE7O995Ep6cvCJolI9nl0FUJ34Y9dTHYLACEz7Ve0KIgCZcrU24K6IFl8vfBEvT+nOGx+tneL5+hlvE1Jcl4UjkiAgCIWKxXnDfKvmIsf463vKFlEL013Gp5P9XfrX6SyxNTxgUqHprSPpGxoUbLyysoUMm4yKG+OC+Sj5Ll3acsyBYKHiYZCIRBy4WPUwymaxh2qf1N26Un89/4unSoTDS10Yw6cXFdbzVKqYeU06nuu4MVkDSNCVaQ0MJMmvxZrOoBZM6WJqW6w7iOby2+h5E3dFBxEOxQj5LwqnURRDM5d4i6sTP7o4ZFKh6638k7TgDmHT+w0d0cs4PIB6Km+STpFm6dHifmj2ODu43y6e+LAn39Z0EZ/qyTyv8MdEq3t7eFU/S59R1Z7ACkr51+yo+YvbREqJOzNK0uruPgeje3g9EnZgd4Znp50b/xBvbrRkglyWDgLzUnmUf4c9PzUqam3Zk9swFuyRtHeGNiXt2Tbjt0txcRvP1SH/znV2Sts60rCO84l63S9Jtl9bsitzayYpftkvS1plWmzC3Q6f5en4DYqH2zFyjxPsAAAAASUVORK5CYII=',
          select: false
        },
        {
          cName: 'vn',
          name: 'Vietnam',
          url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAMAAACVZWnNAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACWFBMVEXaJR3aJR3aJR3aJR3aJh3aJh3aIx3gSxjgSxjaIx3aJR3aIx3skg/skg/aJB3cLxz2zQf2zQfcLxzaIh3iUxf98gL98gLiUxfaIh3riw///wD//wDriw/aJB3bLhz1xgj//wD1xgjbLhzaJR3aJR3aJR3aIh3hUBf87wL87wLhUBfaJR3aJx3bKRzaJx3aJx3aJx3aJB3riBD//gDriBDbKRzaJx3aJB3dNhvskA/zuQnzuAnzuAnzuAnzuAn64wT64wTzuAnzuAnzuQnskQ/dNhvaJB3aJR3aJR3gSBjytQr//gD//gDztQrgSBjaJR3aJR3aIx3bLhzqhBD76QP76gPqhBDbLhzaIx3aJB3aJB3jWRb2ywf//wD2ywfjWhbaJB3aJB3aJR3aJR3aIh3eOhrvoQ399AH99AHvoQzeOhraIh3aIx3aKB3vogzvogzbKB3aIx3aJR3bKRzzuAnzuAnbKRzaIx3gRhn76AP76APgRhnZIh3oehL//QD52QX52QX//QDoehLaJR3bKB3ztgr++QHxrgvfQRnfQRnxrQv++QHztgraIx3fQxn75QP76APpgBHbLBzaIx3aIx3bLBzpgBH75wP75QPfQxnZIR3odhL//AD2yAfiVxbaJB3aJB3aJR3aJB3aJB3iVhb2yAf//ADodhLaJR3bKR3wqAzvoQ3dOBraJR3aJR3aIh3dOBrvoA3wqAzbKR3aJB3cLxzjVxbbKhzaIx3aJR3aIx3bKhziVxbcLxzaJB3aJR3aIx3aJR3aJR3aJR3aIx3aJR3aJR3////j8CPBAAAAAWJLR0THjQVKWwAAAAd0SU1FB+YCCwAGCheHyMYAAAF/SURBVEjHY2AYBYMEMDIxMZKtmZmFlZlszWzsHJzk6uXi5uHl5iJTMx+/gKAQH5mahUVExcSFydQsISklLSNBnl5ZOXkFBUUlWVL0MCqrqIKAipq6hoKCppYalKtMTJRr6+jq6QOBgaGRsYKCsYmhAYinZ2qmTYRmcwtLK2sbGxtbO3sFIHBwtAVynJxdXN2I0Ozu4enlrYAGfHz9/N2J8XRAYFBwCKre0LDwCEbikrlHZFR0TCyS3rj4hMQkYgM8IDklNS0dpjUjMytbNYCE+ErKyc2Dac4vKPQgQSsQFBWXwDSXlhWRppehvKISprmqupw0vQE1tXVAffUNQKKxqYYUHzMwNLe0Kii0tXd0dnUrKPS0NJOkubevX2HCxEmTp0ydNl1hxsxeklw9a/acufPmL1i4cNHiJUuXLZ9FirtXrFy1eo3EWqCWgHXrN2zctHkFCZq3bN22fQc0Te3ctXvP3n0kaObaf+DgIRjn0OEjR0kqBo8dw80bBSMNAAAdJWsoSHlAgAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wMi0xMVQwMDowNjoxMC0wNTowMF+FkKcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDItMTFUMDA6MDY6MTAtMDU6MDAu2CgbAAAAAElFTkSuQmCC',
          select: false
        }
      ],
      selectedFlag: '',
    }
  },
  created() {
    this.setrole();
  },
  async mounted() {
    this.setrole();
  },
  methods: {
    createQuestion(passage) {

      this.$setCookie('utoken', store.getters.getToken);
      this.$setCookie('urole', store.getters.currentUser.authorities[0].authority);
      this.$setCookie('uorganizId', store.getters.currentUser.organizs[0].organizId);


      let lang = this.$i18n.locale== "kr" ? "ko" : this.$i18n.locale;

      if (passage == 'passage') {
        window.open(this.localPath2 + "?&lang=" + lang)
      } else {
        window.open(this.localPath + "?lang=" + lang)
      }

    },
    setrole() {
      for (let i = 0; i < this.country.length; i++) {
        if (this.country[i].cName == this.$i18n.locale) {
          this.selectedFlag = this.country[i].url
        }
      }
      if (this.isLoggedIn) {
        this.currentUser.authorities.forEach(item => {
          if (item.authority === 'ROLE_ADMIN') {
            this.isAdmin = true
          }
        })
      }
    },
    // search() {
    //   let parms = {};
    //   parms['datatime'] = new Date().getTime();
    //   parms['q'] = this.searchval;
    //   this.$router.push({
    //     name: 'datamarket',
    //     query: parms
    //   })
    // },
    logout() {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      if (window.examMode == 'undefined' || window.examMode == undefined) {
        this.$router.push({
          name: 'login'
        })
      } else {
        window.examMode.exitExamMode();
        this.$router.push({
          name: 'login'
        })
      }
    },
    selected(item) {
      this.selectedFlag = item.url;
      this.$i18n.locale = item.cName;
      this.$router.push({
        params: {lang: item.cName}
      })
    },
  }
};
</script>

<style scoped>
.uk-navbar-dropdown {
  margin-top: 0px;
  padding: 15px;
  text-transform: uppercase;
  width: auto;
  min-width: 200px;
}

.li a {
  text-decoration: none;
}

.countryFlag {
  width: 180px;
}

.countryFlag:hover {
  background: rgb(1, 176, 255) !important;
  color: #fff;
  border: 1px solid #d3e0f7;
}

.uk-navbar-nav > li > a {
  text-transform: capitalize;
}

.flagshere {
  width: 40px;
  border: 1px solid rgb(165, 161, 161);
}

router-link {
  cursor: pointer;
}
</style>
